import { useMemo } from "react";

import { useInvoiceSetting, useInvoiceTemplates } from "@/api/services/main/organization/invoice-setting";
import { usePersonInChargeUsers } from "@/api/services/main/user";
import { LoadingPage } from "@/components/elements/Loading/Loading";
import { InvoiceDetailView } from "@/features/organization/invoice/components/invoice-detail/InvoiceDetailView";
import { convertSettingToDetail } from "@/features/organization/invoice/utils/invoiceConverts";

/** 請求設定 tab — read-only 確認 page (組織設定). Resolves labels from setting + template/user masters. */
export const InvoiceDetailPage = () => {
  const { data: settingRes, isLoading: loadingSetting } = useInvoiceSetting();
  const { templates, isLoading: loadingTemplates } = useInvoiceTemplates();
  const { users, isLoading: loadingUsers } = usePersonInChargeUsers();

  const detail = useMemo(
    () => (settingRes?.data ? convertSettingToDetail(settingRes.data, templates, users) : null),
    [settingRes, templates, users],
  );

  if (loadingSetting || loadingTemplates || loadingUsers) return <LoadingPage />;
  if (!detail) return null;

  return <InvoiceDetailView detail={detail} />;
};
